//#region import
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { ApiProject } from 'enum/api';
import { APIStatusCode, EnumLogHistoryMode, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { BtnDraft, BtnReject, BtnSend } from 'components/Button/ButtonAll';
import Tabs, { TabContent, TabItem, TabPanel } from 'components/Input/Tab';
import RequestWorkPlan from './RequestKth21/RequestWorkPlan';
import RequestSpendingPlan from './RequestKth22/RequestSpendingPlan';
import { ProjectContext } from '../ProjectRequestFrom';
//#endregion

const RequestPlan = () => {
    const {
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isChangePanel12,
        setisChangePanel12,
        isChangePanel9,
        setisChangePanel9,
        ObjStepFlowProject,
        isModeSecretary,
        isModalPreview,
        setisModalPreview

    } = useContext(ProjectContext);

    const sBackgroundTab = "rgb(31 101 153)";
    const sBackgroundTabActive = "linear-gradient(rgb(15 188 213) 33%, rgb(75 196 235 / 57%) 71%, rgb(165 246 255 / 68%) 87%, rgb(255, 255, 255) 100%)";
    const [sTabID, setsTabID] = useState("Kth2_Tab1");

    // useEffect(() => {
    // }, []);

    return (
        <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
            <Tabs id={"TabsKth2"} defaultTab={sTabID} onTabChange={(e) => { setsTabID(e); }}>
                <TabItem id="Kth2_Tab1" isSub={true} idHeadSub={"Project_Tab_Kth2"} sBackgroundTab={sBackgroundTab} sBackgroundTabActive={sBackgroundTabActive} >กท. 2/1</TabItem>
                <TabItem id="Kth2_Tab2" isSub={true} idHeadSub={"Project_Tab_Kth2"} sBackgroundTab={sBackgroundTab} sBackgroundTabActive={sBackgroundTabActive} >กท. 2/2</TabItem>
                <TabContent id={"TabContentKth2"}>
                    <TabPanel isSub={true} idHeadSub={"Project_Tab_Kth2"} id="Kth2_Tab1">
                        {/* แผนปฎิบัติงาน 2/1 */}
                        <RequestWorkPlan />
                    </TabPanel>
                    <TabPanel isSub={true} idHeadSub={"Project_Tab_Kth2"} id="Kth2_Tab2">
                        {/* แผนการใช้จ่ายเงิน 2/2 */}
                        <RequestSpendingPlan />
                    </TabPanel>
                </TabContent>
            </Tabs>
        </Grid>
    )
}
export default RequestPlan;